import * as yup from "yup";

export const editValidationSchema = yup.object().shape({
  bankName: yup.string().required("Vui lòng nhập tên ngân hàng"),
  accountNumber: yup.string().required("Vui lòng nhập số tài khoản"),
  accountHolder: yup.string().required("Vui lòng nhập tên chủ tài khoản"),
  isActive: yup.boolean(),
});
